import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import { ContainedRoundedButton } from "../../../../styled/buttons/SecondaryRoundedButton";

const AlternativeProviderItem = ({ provider, onSelect }) => {
  const handleSelectProvider = () => {
    onSelect(provider.provider_id);
  };

  return (
    <div className="grid grid-cols-5 items-center gap-4 border-b border-gray-200 py-3 hover:bg-gray-50">
      <div className="flex flex-col">
        <Typography variant="body2" className="font-medium">
          {provider.provider_name}
        </Typography>
      </div>

      <div className="flex flex-col">
        <Typography variant="body2" className="text-gray-700">
          {provider.provider_address}
        </Typography>
      </div>

      <div className="flex flex-col">
        <Typography variant="body2" className="text-gray-700">
          {provider.provider_types}
        </Typography>
      </div>

      <div className="flex flex-col">
        <Typography variant="body2" className="text-gray-700">
          {provider.distance?.replace(/Distance from \w+/i, "Distance from Client")}
        </Typography>
      </div>

      <div className="flex justify-center">
        <ContainedRoundedButton
          onClick={handleSelectProvider}
          endIcon={<AddCircleOutlineOutlined />}
        >
          Add Provider
        </ContainedRoundedButton>
      </div>
    </div>
  );
};

AlternativeProviderItem.propTypes = {
  provider: PropTypes.shape({
    provider_id: PropTypes.number.isRequired,
    provider_name: PropTypes.string.isRequired,
    provider_address: PropTypes.string.isRequired,
    provider_types: PropTypes.string.isRequired,
    distance: PropTypes.string.isRequired,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default AlternativeProviderItem;
